import { useState, useEffect } from "react";
import { CSVLink } from "react-csv";
import DataTable from "react-data-table-component";
import moment from "moment";
import {
  columns,
  exportAccountsReportHeaders,
} from "../../utils/columns/accountsReport";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import { customStyles, formatNumber } from "../../utils/data/essential";
const firstdate = moment().startOf("month").format("YYYY-MM-DD");
const today = moment().format("YYYY-MM-DD");
const AccountsReport = () => {
  const locations = JSON.parse(localStorage.getItem("locations"));
  const [locationHierarchy, setLocationHierarchy] = useState(locations);
  const [exportData, setExportData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [toDate, setToDate] = useState(today);
  const [fromDate, setFromDate] = useState(firstdate);
  const [isLoading, setIsLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [locationId,setLocationId] = useState(locations[locations.length - 1].id);
  const handler = (id) => {
    localStorage.setItem("locationId", id);
    setIsLoading(true);
    const url = `${baseUrl}/reports/daily/accounts?location=${id}&startdate=${fromDate}&enddate=${toDate}`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setIsLoading(false);
        extractExportData(res);
        extractData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchLocation = (id) => {
    const url = `${baseUrl}/locations/${id}/details`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setLocationHierarchy(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    setLocationHierarchy(locations);
  }, [fromDate, toDate]);
  useEffect(() => {
    setIsLoading(true);
    const url = `${baseUrl}/reports/daily/accounts?location=${locationId}&startdate=${fromDate}&enddate=${toDate}`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setIsLoading(false);
        extractExportData(res);
        extractData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [fromDate, toDate]);
  // extract data to export
  const extractExportData = (data) => {
    const reportData = [];
    let obj = {};
    data?.forEach((el) => {
      obj.location = el.location.name;
      obj.currentAccounts = el.currentAccounts;
      obj.newAccounts = el.newAccounts;
      obj.newHouses = el.newHouses;
      obj.targetAccounts = el.targetAccounts;
      reportData.push(obj);
      obj = {};
    });
    setExportData(reportData);
  };
  const extractData = (data) => {
    const reportData = [];
    let obj = {};
    data?.forEach((el) => {
      obj.location = el.location;
      obj.currentAccounts = formatNumber(el.currentAccounts);
      obj.newAccounts = formatNumber(el.newAccounts);
      obj.newHouses = formatNumber(el.newHouses);
      obj.targetAccounts = formatNumber(el.targetAccounts);
      obj.handler = handler;
      obj.fetchLocation = fetchLocation;
      reportData.push(obj);
      obj = {};
    });
    setReportData(reportData);
  };
  if (isLoading)
    return (
      <div
        className='d-flex justify-content-center'
        style={{ marginTop: "15%" }}
      >
        <h5>Loading...</h5>
      </div>
    );
  return (
    <>
      <div className='mb-4 mt-3 d-flex justify-content-between'>
        <h3 className='ml-3'>Accounts Summary</h3>
        <form className='d-flex pr-3'>
          <div className='d-flex' style={{ height: 40 }}>
            <label className='mr-2 mt-2 ml-3'>From:</label>
            <input
              type='date'
              value={fromDate}
              className='mr-2 h-100 form-control input-select'
              onChange={(e) => {
                setFromDate(e.target.value);
                setLocationId(localStorage.getItem("locationId"));
                fetchLocation(localStorage.getItem("locationId"));
              }}
            />
          </div>
          <div className='d-flex' style={{ height: 40 }}>
            <label className='mr-2 mt-2'>To:</label>
            <input
              type='date'
              className='mr-2 h-100 form-control input-select'
              value={toDate}
              onChange={(e) => {
                setToDate(e.target.value);
                setLocationId(localStorage.getItem("locationId"));
                fetchLocation(localStorage.getItem("locationId"));
              }}
            />
          </div>
        </form>
      </div>
      <div style={{ backgroundColor: "#dfdfdf", height: 3 }} />
      {/* Navigation Section */}
      <div
        className='d-flex flex-wr
      ap mt-3'
      >
        {locationHierarchy?.map((location, index) => (
          <h4
            style={{ cursor: "pointer", marginLeft: index === 0 ? 20 : "" }}
            onClick={() => {
              if (index > locations.length - 2) {
                handler(location.id);
                fetchLocation(location.id);
              }
            }}
          >
            {location.name}
            {location.name !== undefined && (
              <i
                className='fa fa-chevron-right ml-1 mr-1 mb-3'
                style={{
                  fontSize: 15,
                  display: index == 4 ? "none" : "",
                  color: "#0000ff",
                }}
              />
            )}
          </h4>
        ))}
      </div>
      <div className='d-flex justify-content-end mr-3 mt-3'>
        {reportData.length > 0 && (
          <CSVLink
            data={exportData}
            headers={exportAccountsReportHeaders}
            filename={`Accounts_report`}
          >
            <button
              type='button'
              className='btn btn-primary housesTableFilterBtn'
              disabled={reportData.length === 0}
              style={{
                backgroundColor:
                  reportData.length === 0 ? "#cbcbcb" : "#124db1",
                color: reportData.length === 0 ? "#000" : "",
                cursor: reportData.length === 0 ? "default" : "pointer",
              }}
            >
              Excel{" "}
              <i
                style={{ marginLeft: "1rem" }}
                className='fas fa-file-excel'
              ></i>
            </button>
          </CSVLink>
        )}
      </div>
      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={columns}
          data={reportData}
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          striped
          noHeader
        />
      </div>
    </>
  );
};

export default AccountsReport;
